import { render, staticRenderFns } from "./returnFactyDtl.vue?vue&type=template&id=671ce691&scoped=true&"
import script from "./returnFactyDtl.vue?vue&type=script&lang=js&"
export * from "./returnFactyDtl.vue?vue&type=script&lang=js&"
import style0 from "./returnFactyDtl.vue?vue&type=style&index=0&id=671ce691&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ce691",
  null
  
)

export default component.exports